
import { useState, useCallback, useEffect } from "react";

const useGeolocation = () => {
  const [location, setLocation] = useState({
    latitude: sessionStorage.getItem("latitude") || null,
    longitude: sessionStorage.getItem("longitude") || null,
  });

  const [country, setCountry] = useState(sessionStorage.getItem("country") || null);
  const [permissionStatus, setPermissionStatus] = useState("idle");

  const fetchCountry = useCallback(async (latitude, longitude) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&accept-language=en`
      );
      const data = await response.json();
      if (data.address && data.address.country_code) {
        const isoCode = data.address.country_code.toUpperCase();
        setCountry(isoCode);
        if (sessionStorage.getItem("country") !== isoCode) {
          sessionStorage.setItem("country", isoCode);
          window.location.reload();
        }
      }
    } catch (e) {
      console.error("Failed to fetch country from coordinates", e);
    }
  }, []);

  const getUserLocation = useCallback(() => {
    if (!("geolocation" in navigator)) {
      console.error("Geolocation is not available on this device");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        sessionStorage.setItem("latitude", latitude);
        sessionStorage.setItem("longitude", longitude);
        setLocation({ latitude, longitude });
        fetchCountry(latitude, longitude);
      },
      (error) => {
        console.error("Unable to retrieve your location", error);
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  }, [fetchCountry]);

  useEffect(() => {
    if ("permissions" in navigator) {
      navigator.permissions.query({ name: "geolocation" }).then((permission) => {
        setPermissionStatus(permission.state);

        permission.onchange = () => {
          setPermissionStatus(permission.state);

          if (permission.state === "denied") {
            setLocation({ latitude: null, longitude: null });
            setCountry(null);
            sessionStorage.removeItem("latitude");
            sessionStorage.removeItem("longitude");
            sessionStorage.removeItem("country");
          }
        };
      });
    }

    if (location.latitude && location.longitude && !country) {
      fetchCountry(location.latitude, location.longitude);
    }
  }, [location.latitude, location.longitude, country, fetchCountry]);

  return { location, country, getUserLocation, permissionStatus };
};

export default useGeolocation;
